import { Popover, Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import InfoIcon from '@material-ui/icons/Info';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import CustomButton from 'components/CustomInput/Button';
import TimerIcon from '@material-ui/icons/Timer';
import { APPROVED, IRB, SECRETARY, SUSPEND, statusDetailType } from 'utility/lookup';
import { useSelector, useDispatch } from 'react-redux';
import useCommentDialog from 'components/CommentDialog/useCommentDialog';
import { UPDATE_APPLICATION_STATUS_WITH_DETAIL, APPLICATION_LIST_REFRESH } from 'store/key';
import { setGlobalLoading } from 'store/global/reducer';
import useDialog from 'components/ConfirmDialog/useDialog';
import { SITE_RESUME, SITE_RESUME_UPDATED, SUSPEND_SUCCESS, SUSPEND_TIPS } from 'utility/frontendMessage';
import API from 'api/call';

const SLayout = styled.span``;

const SDummy = styled.div``;

const SitePopup = ({ status, data, formId, showPauseIcon }) => {
    const showDialog = useDialog();
    const dispatch = useDispatch();

    const [anchorEl, setAnchorEl] = useState(null);
    const userRole = useSelector((state) => state.user.role);
    const showCommentDialog = useCommentDialog();

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const onClick = (e) => {
        setAnchorEl(e.currentTarget);
    };

    const handleButton = (item) => {
        if (item.suspend) {
            handleResume(item);
        } else {
            handleSuspend(item);
        }
    };

    const handleSuspend = async (item) => {
        const { submit, comment, fileIds } = await showCommentDialog({
            title: SUSPEND_TIPS,
            placeholder: 'Leave your comments or reasons',
            showUploadButton: true,
        });

        if (!submit) {
            return;
        }

        setGlobalLoading(true);

        dispatch({
            type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
            payload: {
                id: formId,
                status: SUSPEND,
                details: [
                    {
                        comment: comment,
                        uploadTempId: fileIds,
                        type: statusDetailType.SITE,
                        value: item.id,
                    },
                ],
                updateApplicationList: true,
                callback: async () => {
                    await showDialog({
                        description: SUSPEND_SUCCESS,
                        disableCancelButton: true,
                    });
                },
                // onError: async (error) => {
                //     showDialog({
                //         description: SUSPEND_FAIL,
                //         disableCancelButton: true,
                //         isError: true,
                //     });
                // },
                final: () => {
                    handlePopoverClose();
                    setGlobalLoading(false);
                },
            },
        });
    };

    const handleResume = async (item) => {
        const isConfirm = await showDialog({
            description: SITE_RESUME,
        });

        if (!isConfirm) {
            return;
        }
        setGlobalLoading(true);
        API.application
            .resumeSite(item.id)
            .then(() => {
                showDialog({
                    description: SITE_RESUME_UPDATED,
                    disableCancelButton: true,
                });
            })
            .finally(() => {
                dispatch({
                    type: APPLICATION_LIST_REFRESH,
                });
                handlePopoverClose();
                setGlobalLoading(false);
            });
    };

    return (
        <SLayout>
            {showPauseIcon ? (
                <InfoIcon fontSize={'small'} style={{ color: '#a9a9a9' }} onClick={onClick} />
            ) : (
                <InfoIcon fontSize={'small'} style={{ color: '#a9a9a9' }} onClick={onClick} />
            )}
            <Popover
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                anchorEl={anchorEl}
                open={!!anchorEl}
                disableRestoreFocus
                disableScrollLock={false}
                onClose={handlePopoverClose}
            >
                <div style={{ padding: '0 10px' }}>
                    {data?.map((item, index) => {
                        const TooltipWrapper = item.suspend ? Tooltip : SDummy;

                        return (
                            <div
                                style={{
                                    padding: '5px 0',
                                    alignItems: 'center',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}
                                key={`${item.code}-${index}`}
                            >
                                <div style={{ paddingRight: 10, fontWeight: 'bold', fontSize: 12, flexShrink: 0 }}>
                                    {item.code}
                                </div>

                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <TooltipWrapper title={item.reason}>
                                            <TimerIcon
                                                fontSize={'small'}
                                                style={{
                                                    marginRight: 3,
                                                    opacity: item.suspend ? 1 : 0,
                                                }}
                                            />
                                        </TooltipWrapper>
                                        <div
                                            style={{
                                                color: item.completed ? '#228B22' : '#DC143C',
                                                width: 20,
                                                height: 20,
                                            }}
                                        >
                                            {item.completed ? (
                                                <CheckIcon fontSize={'small'} />
                                            ) : (
                                                <CloseIcon fontSize={'small'} />
                                            )}
                                        </div>
                                    </div>
                                    {[IRB, SECRETARY].includes(userRole) && status === APPROVED && (
                                        <CustomButton
                                            style={{ width: 100, marginLeft: 6 }}
                                            onClick={() => handleButton(item)}
                                        >
                                            {item.suspend ? 'Resume' : 'Suspend'}
                                        </CustomButton>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Popover>
        </SLayout>
    );
};

export default SitePopup;
